// extracted by mini-css-extract-plugin
export default {"overridesSecondaryHyperlink":"SecondaryHyperlink-module--overrides--SecondaryHyperlink--E0yo7"};